var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

var Notification = (_temp2 = _class = function (_Component) {
  _inherits(Notification, _Component);

  function Notification() {
    var _temp, _this, _ret;

    _classCallCheck(this, Notification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.componentDidMount = function () {
      var timeOut = _this.props.timeOut;

      if (timeOut !== 0) {
        _this.timer = setTimeout(_this.requestHide, timeOut);
      }
    }, _this.componentWillUnmount = function () {
      if (_this.timer) {
        clearTimeout(_this.timer);
      }
    }, _this.handleClick = function () {
      var onClick = _this.props.onClick;

      if (onClick) {
        onClick();
      }
      _this.requestHide();
    }, _this.requestHide = function () {
      var onRequestHide = _this.props.onRequestHide;

      if (onRequestHide) {
        onRequestHide();
      }
    }, _this.renderCloseButton = function () {
      var showCloseButton = _this.props.showCloseButton;

      return showCloseButton ? React.createElement(
        'span',
        { className: 'close-button', onClick: _this.requestHide },
        React.createElement('i', { className: 'close-icon' })
      ) : null;
    }, _this.renderTitle = function () {
      return _this.props.title ? React.createElement(
        'h4',
        { className: 'title' },
        _this.props.title
      ) : null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Notification.prototype.render = function render() {
    var _props = this.props,
        type = _props.type,
        message = _props.message,
        iconClassName = _props.iconClassName;

    var classNames = classnames(['notification', 'notification-' + type, iconClassName]);
    var style = type === 'custom' && this.props.bgColor ? { backgroundColor: this.props.bgColor } : null;

    return React.createElement(
      'div',
      { className: classNames, style: style },
      this.renderCloseButton(),
      React.createElement(
        'div',
        { onClick: this.handleClick },
        this.renderTitle(),
        React.createElement(
          'div',
          { className: 'notification-message', role: 'alert' },
          React.createElement(
            'div',
            { className: 'message' },
            message
          )
        )
      )
    );
  };

  return Notification;
}(Component), _class.defaultProps = {
  type: 'info',
  title: null,
  message: null,
  showCloseButton: true,
  timeOut: 5000,
  onClick: function onClick() {},
  onRequestHide: function onRequestHide() {}
}, _temp2);
Notification.propTypes = process.env.NODE_ENV !== "production" ? {
  type: PropTypes.oneOf(['info', 'success', 'warning', 'error', 'custom']),
  title: PropTypes.node,
  message: PropTypes.node.isRequired,
  showCloseButton: PropTypes.bool,
  timeOut: PropTypes.number,
  onClick: PropTypes.func,
  onRequestHide: PropTypes.func,
  bgColor: PropTypes.string
} : {};


export default Notification;